import { AppId } from './id';
export const buildConfigs = {
    [AppId.uMeds]: {
        launchDarklyProjectKey: 'umeds-chatbot',
    },
    [AppId.alternaleaf]: {
        launchDarklyProjectKey: 'alternaleaf-chatbot',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uZmlnL2J1aWxkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxNQUFNLENBQUM7QUFPN0IsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUErQjtJQUN0RCxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUNiLHNCQUFzQixFQUFFLGVBQWU7S0FDeEM7SUFDRCxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRTtRQUNuQixzQkFBc0IsRUFBRSxxQkFBcUI7S0FDOUM7Q0FDRixDQUFDIn0=